/* eslint-disable */
import React, { Component } from 'react';
import './style.less';

export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    render() {
        const { title, textList, textList1, textList2, textList3, textList4, textList5, textList6 } = this.props;

        return (
            <div className={"textCon"}>
                <div className="content0">
                    <div className="title-wrapper">
                        <h1 className={"title"}><p>{title}&nbsp;</p></h1>
                    </div>
                    <div className="text">
                        {
                            textList && textList.length > 0 && textList.map((text) => {
                                return (
                                    <p className={"textP"}>{text}</p>
                                )
                            })
                        }
                    </div>
                    <div className="idea">
                        <div className="text1">
                            <p className="OnlyTop">{textList1}</p>
                        </div>
                        <div className="text2">
                            <p>{textList2}</p>
                        </div>
                        <div className="text1">
                            <p>{textList3}</p>
                        </div>
                        <div className="text2">
                            <p>{textList4}</p>
                        </div>
                        <div className="text1">
                            <p>{textList5}</p>
                        </div>
                        <div className="text2">
                            <p>{textList6}</p>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

